<a
  (click)="handleMainMenuAction()"
  (keydown.enter)="handleMainMenuAction()"
  role="button"
  tabindex="0"
  class="nav-link"
  [ngClass]="{ active: isMainActive || isOneOfChildrenActive }">
  <i class="nav-icon {{ menuItem.iconClasses }}"></i>
  <p>
    {{ menuItem.name }}
    <i
      *ngIf="isExpandable && menuItem.children.length > 0"
      class="right fas fa-angle-right"
      [@rotate]="false"></i>
  </p>
</a>
<ul
  class="nav nav-treeview"
  *ngFor="let item of menuItem.children"
  [@openClose]="false">
  <li class="nav-item">
    <a
      [routerLink]="item.path"
      [routerLinkActive]="'active'"
      role="link"
      tabindex="0"
      class="nav-link">
      <i class="nav-icon {{ item.iconClasses }}"></i>
      <p>{{ item.name }}</p>
    </a>
  </li>
</ul>
